"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignOut = void 0;
const react_1 = __importDefault(require("react"));
const aws_amplify_1 = require("aws-amplify");
const theme_ui_1 = require("theme-ui");
const ui_components_1 = require("@aws-amplify/ui-components");
async function signOut() {
    try {
        await aws_amplify_1.Auth.signOut();
        // copied from https://github.com/aws-amplify/amplify-js/blob/df95ea3724eb6406f64b03f25086cd3e8644cb5f/packages/amplify-ui-components/src/common/helpers.ts#L34
        // to make the component re-render properly
        aws_amplify_1.Hub.dispatch('UI Auth', {
            event: 'AuthStateChange',
            message: ui_components_1.AuthState.SignedOut,
        });
    }
    catch (error) {
        console.log('error signing out: ', error);
    }
}
const SignOut = ({ onSignOut }) => react_1.default.createElement(theme_ui_1.Button, { onClick: async () => {
        await signOut();
        onSignOut === null || onSignOut === void 0 ? void 0 : onSignOut();
    }, sx: {
        backgroundColor: "#f90",
        paddingLeft: "2em",
        paddingRight: "2em",
    } }, "Sign Out");
exports.SignOut = SignOut;
//# sourceMappingURL=sign-out.js.map